import clsx from "clsx";
import { useFormik } from "formik";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "../../components/Button";
import { AddCircleIcon } from "../../constant";
import Dropdown from "../../components/Dropdown";
import { Input } from "../../components/Input";
import LeftSide from "../../components/LeftSide";
import PaddingContainer from "../../components/PaddingContainer";
import PreviewImagePicker from "../../components/preview-picker";
import SlotsTable from "../../components/SlotsTable";
import Textarea from "../../components/Textarea";
import Title from "../../components/Title";
import addOrEditCourtManagementSchema from "../../schema/addOrEditCourtManagementSchema";
import UploadAndPreviewMultipleImages from "../../components/UploadAndPreviewMultipleImages";
import ManageSlotForm from "../../components/ManageSlotForm";
import AreYouSureModal from "../../modals/AreYouSureModal";
import { daysOfWeek } from "../../data";
import {
  BadmintonIcon,
  CellIcon,
  LocationIcon,
  TextIcon,
} from "../../constant";
import EditCourtManagementModal from "../../modals/CourtManagement/EditCourtManagement";
import useApi from "../../useApi";
import classes from "./EditCourtManagement.module.css";
import { useNavigate } from "react-router-dom";

// import useApi from "../../useApi";
// Create an empty slot object helper - same as in SlotsTable
const createEmptySlot = () => ({
  courtStartTime: null,
  courtEndTime: null,
  courtCharges: "",
  courtDayOfWeek: [],
  active: true,
  slotsData: []
});

const initialValues = {
  courtName: "",
  courtDescription: "",
  courtSportType: "",
  courtSlotDuration: 0,
  courtStatusId: null,
  courtMainImage: null,
  courtThumbnailImage: null,
  courtPreviewImages: [null],
  courtTimings: [],
};
function groupCourtTimings(timings) {
  // Create a map to store the groups
  const groups = new Map();
  // Group by combining start time, end time, and charges as a key
  timings?.forEach((timing) => {
    const key = `${timing.courtStartTime}-${timing.courtEndTime}-${timing.courtCharges}`;
    if (!groups.has(key)) {
      groups.set(key, []);
    }
    groups?.get(key).push(timing);
  });

  // Convert the map to an array of grouped objects
  return Array.from(groups.values());
}
const getDayName = (dayId) => {
  return daysOfWeek.find((item) => item.value === dayId)?.label;
};

const EditCourtManagement = ({ data, onSubmit }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  console.log("id= params", id);
  const { deleteCourtTiming, updateCourt, getCourts, addImages,addCourtTiming, updateImages } =
    useApi();
  const { locations } = useSelector((state) => state?.allPreLoadedApis);
  const [slots, setSlots] = useState([]);
  const [showEditPriceModal, setShowEditPriceModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAreYouSureModal, setShowAreYouSureModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const location = useLocation();
  console.log("locations", locations);

  // Function to handle image API calls
  const processImages = async (images, mainImage, thumbnailImage) => {
    try {
      // Organize images into groups
      const imagesToUpdate = [];
      const imagesToAdd = [];

      // Process preview images array
      if (images && Array.isArray(images)) {
        images
          .filter((img) => img !== null) // Skip null values
          .forEach((image) => {
            if (
              (image.markedForDeletion || image.updated) &&
              image.companyImageId
            ) {
              // Images to update or delete
              imagesToUpdate.push({
                companyImageId: +image.companyImageId,
                companyImage: image.companyImage,
                delete: !!image.markedForDeletion,
              });
            } else if (image.isNew) {
              // New images to add
              imagesToAdd.push({
                courtId: +id,
                companyImage: image.companyImage,
                companyImageTypeId: +image.companyImageTypeId || 3,
              });
            }
          });
      }

      // Process main image
      if (mainImage) {
        if (
          mainImage.companyImageId &&
          (mainImage.updated || mainImage.markedForDeletion)
        ) {
          // Update or delete existing main image
          imagesToUpdate.push({
            companyImageId: +mainImage.companyImageId,
            companyImage: mainImage.companyImage,
            delete: !!mainImage.markedForDeletion,
          });
        } else if (mainImage.companyImage && !mainImage.companyImageId) {
          // Add new main image
          imagesToAdd.push({
            courtId: +id,
            companyImage: mainImage.companyImage,
            companyImageTypeId: 1, // Main image type
          });
        }
      }

      // Process thumbnail image
      if (thumbnailImage) {
        if (
          thumbnailImage.companyImageId &&
          (thumbnailImage.updated || thumbnailImage.markedForDeletion)
        ) {
          // Update or delete existing thumbnail image
          imagesToUpdate.push({
            companyImageId: +thumbnailImage.companyImageId,
            companyImage: thumbnailImage.companyImage,
            delete: !!thumbnailImage.markedForDeletion,
          });
        } else if (
          thumbnailImage.companyImage &&
          !thumbnailImage.companyImageId
        ) {
          // Add new thumbnail image
          imagesToAdd.push({
            courtId: +id,
            companyImage: thumbnailImage.companyImage,
            companyImageTypeId: 2, // Thumbnail image type
          });
        }
      }

      // Make API calls if there are images to process
      const apiCalls = [];

      if (imagesToUpdate.length > 0) {
        apiCalls.push(updateImages({ images: imagesToUpdate }));
      }

      if (imagesToAdd.length > 0) {
        apiCalls.push(addImages({ images: imagesToAdd }));
      }

      if (apiCalls.length === 0) {
        return; // No images to process
      }

      const results = await Promise.all(apiCalls);

      // Check if all API calls were successful
      const allSuccessful = results.every(
        (res) => !res || res?.data?.headers?.error === 200
      );

      if (allSuccessful) {
        toast.success("Images processed successfully");
      } else {
        const errorMessages = results
          .filter((res) => res && res?.data?.headers?.error !== 200)
          .map((res) => res?.data?.headers?.message)
          .join(", ");

        if (errorMessages) {
          toast.error(`Failed to process some images: ${errorMessages}`);
        }
      }
    } catch (error) {
      console.error("Error processing images:", error);
      toast.error("Error processing images");
    }
  };

  const groupByTimeDayAndCharges = (timings) => {
    // Filter out null values first
    const validTimings = timings?.filter(time => time!== null) || [];
    const groupedTimings = {};
    let slotsData = [];
    let courtTimes = [];

    validTimings.forEach((time) => {
      const key = `${time?.courtStartTime}-${time?.courtEndTime}-${time?.courtCharges}`;
      if (!groupedTimings[key]) {
        groupedTimings[key] = [];
      }
      groupedTimings[key].push(time);
    });

    Object.values(groupedTimings).forEach((allTiming) => {
      if (allTiming && allTiming.length > 0) {
        allTiming.forEach((specificTiming) => {
          if(specificTiming?.courtTimingId){
          slotsData.push({
            courtTimingId: specificTiming?.courtTimingId,
            ...specificTiming,
            courtDayOfWeek: specificTiming?.courtDayOfWeek,
          });
        }
        });
      
          courtTimes.push({ ...allTiming[0], ...(slotsData?.length > 0 && { slotsData })  });
        
      }
      slotsData = [];       
    });

    return courtTimes;
  };

  console.log(
    "groupedTimings",
    groupByTimeDayAndCharges(location?.state?.courtTimings)
  );
  const updateCourtApi = async (values) => {
    try {
      setIsSubmitting(true);
      // First update the court basic information
      const response = await updateCourt(values);

      if (response?.data?.headers?.error === 200) {
        // Process all images after court is updated
        await processImages(
          values.courtPreviewImages,
          values.courtMainImage,
          values.courtThumbnailImage
        );

        toast.success("Court updated successfully");
        resetForm();
        navigate("/court-management");
      } else {
        toast.error(
          response?.data?.headers?.message || "Failed to update court"
        );
      }
    } catch (error) {
      console.error("Error updating court:", error);
      toast.error("An error occurred while updating the court");
    } finally {
      setIsSubmitting(false);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema: addOrEditCourtManagementSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (values, { resetForm }) => {
      console.log("values", values);
      console.log("slots ==>", slots);
      if (slots?.some((slot) => slot == null)) {
        toast.error("Please add at least one slot");
        return;
      }

      let noOfWeekSlotsDetail = [];
      slots.forEach((slot) => {
        console.log("forEachSlot", slot);
        slot?.courtDayOfWeek?.forEach((day) => {
          noOfWeekSlotsDetail.push({
            ...slot,
            courtDayOfWeek: day,
            courtStartTime: moment(slot.startTime).format("HH:mm:ss"),
            courtEndTime: moment(slot.endTime).format("HH:mm:ss"),
            courtTimingId: null,
            courtId: null,
            active: true,
            courtMinAmount: 0,
          });
        });
      });

      const params = {
        // Format the data for submission
        courtId: id,
        courtName: values.courtName,
        courtDescription: values.courtDescription,
        courtSportType: values.courtSportType,
        courtSlotDuration: values.courtSlotDuration,
        courtStatusId: values.courtStatusId,
        courtMainImage: values.courtMainImage,
        courtThumbnailImage: values.courtThumbnailImage,
        courtStatusId: 1,
        locationId: values.locationId,
        courtTimings: noOfWeekSlotsDetail?.map((item) => ({
          ...item,
          courtDayOfWeek: item?.courtDayOfWeek?.days,
        })),
        courtSlotDuration: 30,
        courtPreviewImages: values.courtPreviewImages.filter(
          (img) => img !== null
        ),
      };

      updateCourtApi(params);
    },
  });

  const {
    touched,
    errors,
    values,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
    validateForm,
    resetForm,
  } = formik;

  const handleChangeWithTouch = (field) => (value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };

  // Format courtTimings errors for SlotsTable component

  // Handle slot deletion
  const handleSlotDelete = (index, data) => {
    console.log("Coming data", data);
    if (data?.courtTimingId || data?.length > 0) {
      setShowAreYouSureModal(true);
      setSelectedData(data);
    } else {
      // const updatedSlots = [...slots];
      // updatedSlots.splice(index, 1);
      setFieldValue("courtTimings", values?.courtTimings?.filter(item => item?.courtTimingId !== data?.courtTimingId));
      // setSlots(updatedSlots);
    }
  };

  // Handle adding a new slot
  const handleAddSlot = () => {
    if(values?.courtTimings?.some(item => item?.courtTimingId== undefined)){
      toast.error("Please add slot");
      return;
    }
    const emptySlot = createEmptySlot();
    setFieldValue("courtTimings", [...values?.courtTimings, emptySlot]);
  };

  console.log("slots primilinary", slots);
  // Debug errors - you can remove this in production

  const controlsData = [
    {
      id: 1,
      label: "Court Name",
      name: "courtName",
      placeholder: "Enter Court Name",
      leftIcon: <LeftSide icon={<BadmintonIcon className={classes.icon} />} />,
    },
    {
      id: 2,
      label: "Court Type",
      name: "courtSportType",
      placeholder: "Select Court Type",
      leftIcon: <LeftSide icon={<CellIcon className={classes.icon} />} />,
    },
    {
      id: 3,
      label: "Location",
      name: "locationId",
      placeholder: "Select Location",
      leftIcon: <LeftSide icon={<LocationIcon className={classes.icon} />} />,
    },
    {
      id: 4,
      label: "Description",
      name: "courtDescription",
      placeholder: "Enter Description",
      leftIcon: <LeftSide icon={<TextIcon className={classes.icon} />} />,
    },
  ];

  // Add a new function to handle discarding changes
  const handleDiscardChanges = () => {
    // Reset the formik form to initial values
    resetForm();
    // Clear the slots array
    setSlots([]);

    // Show a confirmation toast
    toast.info("Changes discarded");
  };

  const handleDeleteCourtTimings = async (data) => {
    console.log("Coming data", data);
    try {
      if (Array.isArray(data)) {
        await handleMultipleDeletions(data);
      } else {
        await handleSingleDeletion(data);
      }
    } catch (error) {
      console.error("Error deleting court timing:", error);
      toast.error("An error occurred while deleting the slot(s)");
    }
  };

  const handleMultipleDeletions = async (data) => {
    const deletePromises = data.map((item) =>
      deleteCourtTiming({ courtTimingId: item.courtTimingId })
    );

    const results = await Promise.allSettled(deletePromises);
    const { allSuccessful, failedDeletions } =
      processMultipleDeletionResults(results);

    if (allSuccessful) {
      updateCourtTimingsAfterMultipleDeletion(data);
      toast.success("Selected slots deleted successfully");
    } else {
      handleMultipleDeletionFailures(failedDeletions);
    }
  };

  const processMultipleDeletionResults = (results) => {
    const allSuccessful = results.every(
      (result) =>
        result.status === "fulfilled" &&
        result.value?.data?.headers?.error === 200
    );

    const failedDeletions = results
      .filter(
        (result) =>
          result.status === "rejected" ||
          result.value?.data?.headers?.error !== 200
      )
      .map((result) =>
        result.status === "rejected"
          ? "Unknown error"
          : result.value?.data?.headers?.message
      );

    return { allSuccessful, failedDeletions };
  };

  const updateCourtTimingsAfterMultipleDeletion = (data) => {
    const deletedIds = data.map((item) => item.courtTimingId);
    setFieldValue(
      "courtTimings",
      values?.courtTimings?.filter(
        (item) => !deletedIds.includes(item?.courtTimingId)
      )
    );
  };

  const handleMultipleDeletionFailures = (failedDeletions) => {
    toast.error(`Failed to delete some slots: ${failedDeletions.join(", ")}`);
  };

  const handleSingleDeletion = async (data) => {
    const result = await deleteCourtTiming({
      courtTimingId: data?.courtTimingId,
    });

    if (result?.data?.headers?.error === 200) {
      updateCourtTimingsAfterSingleDeletion(data);
      toast.success("Slot deleted successfully");
    } else {
      toast.error(result?.data?.message);
    }
  };

  const updateCourtTimingsAfterSingleDeletion = (data) => {
    setFieldValue(
      "courtTimings",
      values?.courtTimings?.filter(
        (item) => item?.courtTimingId !== data?.courtTimingId
      )
    );
  };

  const getCourtById = async (courtId) => {
    try {
      const response = await getCourts({
        id: +courtId,
        search: "",
        pageNumber: 1,
        pageSize: 1,
        showInactive: true,
        showUpcoming: true,
      });
      if (response?.data?.headers?.error === 200) {
        console.log("Court data fetched:", response?.data?.data);
        return response;
      } else {
        toast.error(response?.data?.message || "Failed to fetch court data");
        return null;
      }
    } catch (error) {
      console.error("Error fetching court:", error);
      toast.error("Error fetching court data");
      return null;
    }
  };
  useEffect(() => {
    // Check for court ID from URL params
    const fetchCourtData = async () => {
      try {
        // If we have data in location state, use it
        if (location?.state) {
          populateFormFromData(location.state);
        }
        // Otherwise, if we have an ID, fetch the data from API
        else if (id) {
          console.log("Fetching court data by ID:", id);
          const response = await getCourtById(id);

          if (response?.data?.headers?.error === 200) {
            console.log("Court data fetched successfully");
            populateFormFromData(response?.data?.body?.items[0]);
          } else {
            toast.error("Failed to fetch court data");
          }
        }
      } catch (error) {
        console.error("Error loading court data:", error);
        toast.error("Error loading court data");
      }
    };

    fetchCourtData();
  }, [id, location?.state]);

  // Helper function to populate form data from either navigation state or API response

  const groupCourtTimings1 = (timings) => {
    let groupedTimings = [];
    timings?.forEach((timing) => {
      const key = `${timing.courtStartTime}-${timing.courtEndTime}-${timing.courtCharges}`;
      if (!groupedTimings[key]) {
        groupedTimings[key] = [];
      }
      groupedTimings[key].push(timing);
    });
    return groupedTimings;
  };
  const populateFormFromData = (courtData) => {
    console.log("courtData", courtData);
    setFieldValue("courtName", courtData?.courtName);
    setFieldValue("courtDescription", courtData?.courtDescription);
    setFieldValue("courtSportType", courtData?.courtSportType);
    setFieldValue("locationId", courtData?.location?.locationId);
    setFieldValue("courtStatusId", courtData?.courtStatusId);
    setFieldValue(
      "courtMainImage",
      courtData?.courtImages?.find((image) => image?.companyImageTypeId == 1)
    );
    setFieldValue(
      "courtThumbnailImage",
      courtData?.courtImages?.find((image) => image?.companyImageTypeId == 2)
    );
    setFieldValue(
      "courtPreviewImages",
      courtData?.courtImages?.filter((image) => image?.companyImageTypeId == 3)
    );
    console.log(
      "Evaluated Result",
      groupCourtTimings1(courtData?.courtTimings)
    );
    const result = groupCourtTimings(courtData?.courtTimings);
    console.log("Result", result);
    let slotsData = [];
    // let newSlot = null;
    // result?.forEach((timing) => {
    //   let daysOfWeek = [];
    //   newSlot = null;
    //   timing?.forEach((item) => {
    //     newSlot = item;
    //     console.log("item", item);
    //     daysOfWeek.push({
    //       days: item?.courtDayOfWeek,
    //       courtTimingId: item?.courtTimingId,
    //     });
    //   });
    //   slotsData.push({ ...newSlot, courtDayOfWeek: daysOfWeek });
    // });
    // setSlots(slotsData);
    setFieldValue("courtTimings", courtData?.courtTimings);
  };

  console.log("values ==",values)

  // useEffect(() => {
  //   const result = groupCourtTimings(values?.courtTimings);
  //   console.log("Result", result);
  //   let slotsData = [];
  //   let newSlot = null;
  //   result?.forEach((timing) => {
  //     let daysOfWeek = [];
  //     newSlot = null;
  //     timing?.forEach((item) => {
  //       newSlot = item;
  //       console.log("item", item);
  //       daysOfWeek.push({
  //         days: item?.courtDayOfWeek,
  //         courtTimingId: item?.courtTimingId,
  //       });
  //     });
  //     slotsData.push({ ...newSlot, courtDayOfWeek: daysOfWeek });
  //   });
  //   setSlots(slotsData);
  // }, [values?.courtTimings]);

  console.log("errors", errors);
  console.log("values Edit", values);
  const addCourtTimingAPi = async (data) => {
    try {
      const response = await addCourtTiming(data);
      if (response?.data?.headers?.error === 200) {
        // Create a new slot object with the response data
        

        // Get current court timings and remove the last empty slot
        const currentTimings = values?.courtTimings || [];
        const updatedTimings = currentTimings.slice(0, -1).concat(response?.data?.body?.[0]);

        // Update the courtTimings state with the new slot
        setFieldValue("courtTimings", updatedTimings);
        toast.success("Court Timing Added Successfully");
      } else {
        toast.error(response?.data?.headers?.message || "Failed to add court timing");
      }
    } catch (error) {
      console.error("Error adding court timing:", error);
      toast.error("An error occurred while adding the court timing");
    }
  };
  return (
    <>
      <PaddingContainer>
        <div className={classes.titleWrapper}>
          <Title title={location?.state ? "Edit Court" : "Add Court"} />
        </div>

        <section className={classes.wrapper}>
          <header>
            <h3 className={classes.formTitle}>
              Fill out the Court Information
            </h3>
          </header>

          <div className={classes.formContainer}>
            <form onSubmit={handleSubmit}>
              <Row className={classes.row}>
                <Col xs={12} md={6}>
                  <PreviewImagePicker
                    id="courtMainImage"
                    label="Upload Court Main Image"
                    name="courtMainImage"
                    onChange={(file) =>
                      setFieldValue("courtMainImage", {
                        companyImage: file,
                        companyImageId: values.courtMainImage?.companyImageId,
                        updated: !!values.courtMainImage?.companyImageId,
                        companyImageTypeId: 1,
                      })
                    }
                    value={values.courtMainImage?.companyImage}
                    errorText={touched.courtMainImage && errors.courtMainImage}
                  />
                </Col>
                <Col xs={12} md={6}>
                  <PreviewImagePicker
                    id="courtThumbnailImage"
                    label="Upload Court Thumbnail"
                    name="courtThumbnailImage"
                    onChange={(file) =>
                      setFieldValue("courtThumbnailImage", {
                        companyImage: file,
                        companyImageId:
                          values.courtThumbnailImage?.companyImageId,
                        updated: !!values.courtThumbnailImage?.companyImageId,
                        companyImageTypeId: 2,
                      })
                    }
                    value={values.courtThumbnailImage?.companyImage}
                    errorText={
                      touched.courtThumbnailImage && errors.courtThumbnailImage
                    }
                  />
                </Col>

                {controlsData?.map(
                  ({ leftIcon, name, label, id, placeholder }, index) => {
                    if (name === "locationId") {
                      return (
                        <Col xs={12} md={4} key={id}>
                          <Dropdown
                            options={locations?.map((data) => ({
                              label: data?.locationName,
                              value: data?.locationId,
                            }))}
                            icon={<LeftSide icon={<LocationIcon />} />}
                            customStyle={{ gap: "4px" }}
                            inputStyle={{ paddingLeft: "0" }}
                            labelStyle={{ fontSize: "16px" }}
                            label={"Location"}
                            placeholder="Select Location"
                            value={values?.locationId}
                            onChange={handleChangeWithTouch("locationId")}
                            errorText={
                              touched?.locationId && errors?.locationId
                            }
                          />
                        </Col>
                      );
                    } else if (name === "courtDescription") {
                      return (
                        <Col xs={12} md={12} key={id}>
                          <Textarea
                            isOptional={true}
                            col={30}
                            row={100}
                            label="Court Description"
                            id="courtDescription"
                            value={values.courtDescription}
                            onChange={handleChangeWithTouch("courtDescription")}
                            placeholder="Enter Court Description"
                          />
                        </Col>
                      );
                    }
                    return (
                      <Col
                        xs={12}
                        key={id}
                        md={controlsData?.length - 1 === index ? 12 : 4}
                      >
                        <Input
                          leftIcon={leftIcon}
                          customStyle={{ gap: "15px" }}
                          inputStyle={{ paddingLeft: "0" }}
                          labelStyle={{ fontSize: "16px" }}
                          label={label}
                          placeholder={placeholder}
                          value={values?.[name]}
                          onChange={handleChangeWithTouch(name)}
                          errorText={touched?.[name] && errors?.[name]}
                        />
                      </Col>
                    );
                  }
                )}

                <Col xs={12} md={12}>
                  <UploadAndPreviewMultipleImages
                    companyImageTypeId={3}
                    id={id}
                    value={values.courtPreviewImages}
                    setter={(images) =>
                      setFieldValue("courtPreviewImages", images)
                    }
                  />
                </Col>

                <Col xs={12}>
                  <div className={classes.buttonWrapper}>
                    <Button
                      type="button"
                      variant="secondary"
                      className={classes.submitButton}
                      onClick={handleDiscardChanges}
                      disabled={isSubmitting}
                    >
                      Discard Changes
                    </Button>
                    <Button
                      type="submit"
                      variant="primary"
                      className={classes.submitButton}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </Button>
                  </div>
                </Col>
              </Row>
            </form>
          </div>
        </section>

        <section className={clsx(classes.wrapper, classes["mt-10"])}>
          <form className={classes.slotsForm}>
            <Col xs={12} md={12}>
              <div>
                {typeof errors.courtTimings === "string" && (
                  <div className={classes.errorText}>{errors.courtTimings}</div>
                )}
              </div>
              <div className={classes.addSlotButton}>
                <h2 className={classes.subFormTitle}>Pricing</h2>
                <Button
                  variant="primary"
                  onClick={handleAddSlot}
                  leftIcon={<AddCircleIcon />}
                  label={"Add Slot"}
                />
              </div>
              {/* <SlotsTable
              
                courtTimings={values?.courtTimings}
              setCourtsTiming={setFieldValue}
                editMode={id}
                slots={slots}
                onChange={setSlots}
                onDelete={handleSlotDelete}
                onAdd={handleAddSlot}
                errors={getFormattedTimingErrors()}
                touched={touched.courtTimings || []}
              /> */}
            {groupByTimeDayAndCharges(values?.courtTimings)?.length > 0 ? <div className={classes.slotContainer}>
                {groupByTimeDayAndCharges(values?.courtTimings)?.map(
                  (timing, index) => {
                    return (
                      <ManageSlotForm
                        courtId={id}
                        onSaveCourtTime={addCourtTimingAPi}
                        onDelete={(data) => handleSlotDelete(index, data)}
                        key={timing?.courtTimingId}
                        slot={timing}
                      />
                    );
                  }
                )}
              </div> : <div className={classes.noSlotContainer}>Click on Add Slot to add pricing</div>}
            </Col>
          </form>
        </section>
      </PaddingContainer>
      {showEditPriceModal && (
        <EditCourtManagementModal
          show={showEditPriceModal}
          setShow={setShowEditPriceModal}
          onSubmit={() => {}}
        />
      )}
      {showAreYouSureModal && (
        <AreYouSureModal
          title="Slot(s)"
          data={
            Array.isArray(selectedData)
              ? selectedData
                  ?.map((item) => getDayName(item?.courtDayOfWeek))
                  .join(", ")
              : getDayName(selectedData?.courtDayOfWeek)
          }
          show={showAreYouSureModal}
          setShow={setShowAreYouSureModal}
          onConfirm={() => {
            handleDeleteCourtTimings(selectedData);
            setShowAreYouSureModal(false);
          }}
        />
      )}
    </>
  );
};

export default EditCourtManagement;
